import { useEffect, useState } from "react";
import "./AppPTOPolicies.css";
import { PaidTimeOffPolicy } from "winslow-core";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/features/appData";
import { useNavigate } from "react-router-dom";

type AppPTOPoliciesProps = {
    ptoPolicies: PaidTimeOffPolicy[] | undefined;
}

export const AppPTOPolicies = ({ptoPolicies} : AppPTOPoliciesProps) => {

    const navigate = useNavigate();
    const storeUser = useSelector(selectUser);
        
    return (
        <>
            {ptoPolicies && ptoPolicies.length > 0 && 
                ptoPolicies.map((ptoPolicy: PaidTimeOffPolicy, index: number) => {
                    return (
                        <div 
                            className="pto-policy-card"
                            key={ptoPolicy.id}
                            onClick={() => {
                                navigate("/app/time-off/policy-editor/" + ptoPolicy.id);
                            }}
                        >
                            
                            <div className="pto-policy-name">
                                {ptoPolicy.name}
                            </div>
                            <div className="pto-policy-description">
                                {ptoPolicy.description}
                            </div>
                            <div className="pto-policy-type">
                                {ptoPolicy.type}
                            </div>
                        </div>
                    )
                })
            }

                
            {/* <div className="app-time-off-grid">
                <div className="app-time-off-grid-header-item">Name</div>
                <div className="app-time-off-grid-header-item">Description</div>
                <div className="app-time-off-grid-header-item">Type</div>
                <div className="app-time-off-grid-header-item">Effective Hours</div>

                Add policies divs in here
            </div> */}
        </>

    )
}